<template>
	<div class="RetrievePassword">
		<div class="RegistWarp">
		<div class="leftwarp">
			<div class="imgbox">
				<img src="@/assets/imgs/login/logo1.png" />
			</div>
			<div class="toptitleBox">
				<div class="returnhome" @click="gopage">
					<i class='el-icon-caret-left' /> 返回</div>
				<div class="handleBox">
					<div class="loginbtn" v-if="pagename">{{pagename}}</div>
				</div>
			</div>
			<!-- <div class="handleBox">
				<div class="loginbtn" v-if="pagename">{{pagename}}</div>
			</div> -->
			<div class="formbox">
				<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="formwarp" label-position='top'>
					<el-form-item label="手机号" prop="phoneNum">
						<el-row :gutter="20">
							<el-col :span="24">
								<el-input v-model="ruleForm.phoneNum" @blur='blurFn($event.target.value)'></el-input>
							</el-col>
							<!-- <el-col :span="6" style="padding:0px">

								<div class="getcodebtn" @click="getcodeFn">
									<el-button :disabled='disable'>{{showtimeContent}}</el-button>
								</div>
							</el-col> -->
						</el-row>
					</el-form-item>
					<!-- <el-form-item label="验证码" prop="identfyCode">
						<el-input v-model="ruleForm.identfyCode"></el-input>
					</el-form-item> -->
					<el-form-item label="密码" prop="newPassword1">
						<el-input type="password"  v-model="ruleForm.newPassword1" show-password></el-input>
					</el-form-item>
					<el-form-item label="再次输入密码" prop="newPassword2">
						<el-input type="password" v-model="ruleForm.newPassword2" show-password></el-input>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" class="savebtnbox" @click="submitForm('ruleForm')" style="width:100%">提交</el-button>
					</el-form-item>
				</el-form>
			</div>
			<div class="tiptext">
				如果您有任何疑问或在登录过程中遇到任何困难，您都可以通过以下方式与我们联系电话：17200303981
			</div>
		</div>
		<div class="rightwarp">
			<img src="@/assets/imgs/login/logo2.png" />
			<div class="textBox">
				<div>欢迎登录</div>
				<div>中国人才交流协会</div>
			</div>
		</div>
	</div>
	</div>
</template>
<script>
import { httpService } from "@/service/httpService";
export default {
	data() {
		var validatePass2 = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('请再次输入密码'));
			} else if (value !== this.ruleForm.newPassword1) {
				callback(new Error('两次输入密码不一致!'));
			} else {
				callback();
			}
		};
		return {
			showtime: '',
			showtimeContent: '发送验证码',
			disable: true,
			ruleForm: {
				phoneNum: '',
				code: '9999',
				newPassword1: '',
				newPassword2: '',
			},
			rules: {
				phoneNum: [
					{ required: true, message: '请输入手机号', trigger: 'blur' },
					{
						required: true, message: '请输入正确的手机号码', pattern: /^1[3|4|5|7|8][0-9]\d{8}$/, trigger: 'blur'
					}
				],
				code: [
					{ required: true, message: '请输入验证码', trigger: 'blur' },
				],
				newPassword1: [
					{ required: true, message: '请输入密码', trigger: 'blur' },
				],
				newPassword2: [
					{ required: true, message: '请再次确认密码', trigger: 'blur' },
					{ validator: validatePass2, trigger: 'blur', required: true }
				],
			},
			pagename: '',
		}
	},
	created() {
		this.pagename = this.$route.query.name
	},
	methods: {
		submitForm(formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					// let newformdata=JSON.parse(JSON.stringify(this.ruleForm))
					// delete newformdata.newPassword2
					httpService.resetPassword(this.ruleForm).then(res => {
						if (res.code == 200) {
							this.$message({
								message: '密码已重置，请重新登录',
								type: 'success'
							});
							sessionStorage.clear()
							this.$router.push('/login');
						}else{
							 this.$message.error(res.message);
						}
					});
				} else {
					return false;
				}
			});
		},
		blurFn(value) {
			if (value) {
				this.disable = false
			}
		},
		async getcodeFn() {
			let data = await httpService.phoneCodeFn(this.ruleForm.phoneNum);
			if (data.code == 200) {
				this.showtime = 120,
					this.showtimeContent = '已发送'
				this.disable = true
				// this.newsData = data.result.list
				let timeChange;
				//关键在于用ti取代time进行计算和判断，因为time在render里不断刷新，但在方法中不会进行刷新
				const clock = () => {
					let ti = this.showtime;
					if (ti > 1) {
						//当ti>0时执行更新方法
						ti = ti - 1;
						this.showtime = ti,
							this.showtimeContent = '已发送' + ti + 's'
					} else {
						//当ti=0时执行终止循环方法
						clearInterval(timeChange);
						this.showtime = '',
							this.showtimeContent = '发送验证码',
							this.disable = false
					}
				};

				// 弹框
				if (this.disable) {
					//每隔一秒执行一次clock方法
					timeChange = setInterval(clock, 1000);
				} else {
					clearInterval(timeChange);
				}
			}
		},
		gopage() {
			this.$router.go(-1)
		}
	}
}
</script>
<style lang="less" scoped>
.RetrievePassword{
	background: url(../assets/imgs/login/img1.png) #fff no-repeat;
	background-size: 100% 100%;
    // overflow: hidden;
    width: 100%;
    height: 100%;
	box-sizing: border-box;
	margin: auto;
	position: absolute;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	.RegistWarp {
		width: 1200px;
		margin: 0 auto;
		padding: 60px 0 0px 0px;
		box-sizing: border-box;
		box-sizing: border-box;
		min-height: 937px;
		// background: url(../assets/imgs/login/img1.png) #fff;
		display: flex;
		flex-direction: row;
		box-sizing: border-box;
		.leftwarp {
			display: flex;
			flex-direction: column;
			width: 588px;
			align-items: center;
			.imgbox {
				width: 98px;
				height: 98px;
				background: #fff;
				box-shadow: 0px 15px 16px rgba(0, 0, 0, 0.07);
				border-radius: 12px;
				display: flex;
				justify-content: center;
				align-items: center;
				margin-bottom: 36px;
				img {
					width: 65px;
					height: 60px;
					
				}
			}
			.toptitleBox {
				width: 100%;
				display: flex;
				flex-direction: row;
				align-items: center;
				margin-bottom: 33px;
				font-size: 22px;
				.returnhome {
					width: 130px;
					// font-size: 24px;
					color: #0083ff;
					cursor: pointer;
				}
			}
			.handleBox {
				width: 80%;
				display: flex;
				flex-direction: row;
				justify-content: space-around;
				padding:0 133px 0 0;
				box-sizing: border-box;
				// margin-bottom: 33px;
				.loginbtn {
					font-size: 24px;
					color: #333333;
					cursor: pointer;
				}
				.registbtn {
					font-size: 24px;
					color: #0083ff;
				}
			}
			.formbox {
				// height: 712px;
				box-shadow: 0px 3px 10px rgba(232, 232, 232, 0.52);
	
				.formwarp {
					width: 588px;
					box-sizing: border-box;
					background: #fff;
					padding: 60px 73px 40px 73px;
					.getcodebtn {
						/deep/.el-button {
							border: none;
							width: 104px;
							height: 45px;
							background: rgba(0, 131, 255, 0.1);
							color: #0083ff;
							font-size: 16px;
							text-align: center;
							padding: 0;
						}
					}
					/deep/.el-form-item {
						margin-bottom: 20px;
					}
					/deep/.el-form-item__label {
						line-height: 0;
					}
					/deep/.el-input__inner {
						height: 45px;
						line-height: 45px;
					}
					.savebtnbox {
						height: 45px;
						background: #0083ff;
						font-size: 16px;
						box-shadow: 0px 7px 22px rgba(103, 154, 255, 0.44);
						margin-top: 20px;
					}
				}
			}
			.tiptext {
				width:560px;
				font-size: 16px;
				line-height: 24px;
				color: #a6a9b7;
				margin: 21px 0;
			}
		}
		.rightwarp {
			margin: 200px 0 0 120px;
			.textBox {
				font-size: 60px;
				font-weight: bold;
				line-height: 88px;
				color: #ffffff;
				margin-top: 22px;
			}
		}
		/deep/.dialogcenterbox {
			padding: 0px 0 90px 0;
			display: flex;
			flex-direction: column;
			align-items: center;
			.text1 {
				font-size: 22px;
				font-weight: bold;
				line-height: 32px;
				color: #333333;
				margin: 46px 0;
			}
			.text2 {
				font-size: 16px;
				line-height: 30px;
				color: #666666;
			}
		}
	}
}
</style>


